import AppsOutlined from '@mui/icons-material/AppsOutlined';
import HelpOutlineOutlined from '@mui/icons-material/HelpOutlineOutlined';
import KeyboardArrowDownOutlined from '@mui/icons-material/KeyboardArrowDownOutlined';
import KeyboardArrowUpOutlined from '@mui/icons-material/KeyboardArrowUpOutlined';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { typedMemo } from '@utils';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const NavigationMenuFooter = typedMemo(() => {
  const { t } = useTranslation();
  const [appMenuOpen, setAppMenuOpen] = useState(false);
  const toggleAppMenu = useCallback(
    () => setAppMenuOpen((value) => !value),
    [],
  );

  const [serviceMenuOpen, setServiceMenuOpen] = useState(false);
  const toggleServiceMenu = useCallback(
    () => setServiceMenuOpen((value) => !value),
    [],
  );

  const serviceMenuItems = [
    {
      href: 'https://portal.brz365.eu/',
      translationKey: 'navigationMenuFooter.portal',
    },
    {
      href: 'https://portal.brz365.eu/online-hilfe/webhooks',
      translationKey: 'navigationMenuFooter.help',
    },
    {
      href: 'https://www.brz.eu/de/impressum',
      translationKey: 'navigationMenuFooter.imprint',
    },
  ];

  return (
    <Box sx={{ mt: 'auto' }}>
      <Divider />
      <List>
        <ListItemButton onClick={toggleAppMenu}>
          <ListItemIcon>
            <AppsOutlined />
          </ListItemIcon>
          <ListItemText primary={t('navigationMenuFooter.anwendungen')} />
          {appMenuOpen ? (
            <KeyboardArrowDownOutlined />
          ) : (
            <KeyboardArrowUpOutlined />
          )}
        </ListItemButton>
        <Collapse in={appMenuOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding></List>
        </Collapse>

        <ListItemButton onClick={toggleServiceMenu}>
          <ListItemIcon>
            <HelpOutlineOutlined />
          </ListItemIcon>
          <ListItemText primary={t('navigationMenuFooter.service')} />
          {serviceMenuOpen ? (
            <KeyboardArrowDownOutlined />
          ) : (
            <KeyboardArrowUpOutlined />
          )}
        </ListItemButton>
        <Collapse in={serviceMenuOpen} timeout="auto" unmountOnExit>
          {serviceMenuItems.map((item) => (
            <ListItem key={item.href}>
              <ListItemButton sx={{ pl: 4 }} href={item.href} target="_blank">
                <ListItemText primary={t(item.translationKey)} />
              </ListItemButton>
            </ListItem>
          ))}
        </Collapse>
      </List>
    </Box>
  );
});
